// Header.jsx
import React, { useState } from 'react';
import { Menu, X } from 'lucide-react'; // Imports hamburger and close icons
import { designTokens, styles } from './MainPage.styles';

export default function Header({ scrolled, activeSection, scrollToSection }) {
  const [isOpen, setIsOpen] = useState(false);

  // Helper to handle clicks smoothly on mobile views
  const handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
    setIsOpen(false); // Auto-closes mobile drawer after choosing an element
  };

  return (
    <nav style={{
      ...styles.nav,
      backgroundColor: scrolled || isOpen ? 'rgba(13, 27, 42, 0.98)' : designTokens.navy,
      boxShadow: scrolled || isOpen ? '0 10px 30px -10px rgba(0,0,0,0.4)' : 'none',
    }}>
      {/* Dynamic responsive styles injection */}
      <style>{`
        /* Toggle display logic across breakpoints */
        .desktop-nav-links {
          display: flex;
        }
        .mobile-toggle-btn {
          display: none;
        }

        @media (max-width: 991px) {
          .desktop-nav-links {
            display: ${isOpen ? 'flex' : 'none'} !important;
            flex-direction: column;
            position: absolute;
            top: 70px;
            left: 0;
            width: 100%;
            background-color: rgba(13, 27, 42, 0.98);
            border-bottom: 2px solid ${designTokens.gold};
            padding: 24px 40px;
            gap: 20px !important;
            align-items: flex-start !important;
            box-sizing: border-box;
            z-index: 99998;
          }
          
          .mobile-toggle-btn {
            display: block !important;
            background: none;
            border: none;
            color: ${designTokens.white};
            cursor: pointer;
            padding: 4px;
            z-index: 99999;
          }

          .nav-action-btn {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>

      <div style={styles.navContainer}>
        {/* LOGO */}
        <div style={styles.logo} onClick={() => handleNavClick('home')}>
          Book<span style={{ color: designTokens.gold }}>Policy</span>Guard<span style={styles.trademark}>™</span>
        </div>

        {/* MOBILE HAMBURGER BUTTON */}
        <button 
          type="button" 
          className="mobile-toggle-btn"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation menu"
        >
          {isOpen ? <X size={24} style={{ color: designTokens.gold }} /> : <Menu size={24} />}
        </button>

        {/* NAVIGATION LINKS CONTAINER */}
        <div style={styles.navLinks} className="desktop-nav-links">
          {[
            { id: 'home', label: 'Overview' },
            { id: 'problem', label: 'The Problem' },
            { id: 'features', label: 'Features' },
            { id: 'how', label: 'How It Works' },
            { id: 'simulator', label: 'Simulator' },
            { id: 'faq', label: 'FAQ' }
          ].map((sec) => (
            <button 
              key={sec.id}
              type="button"
              onClick={() => handleNavClick(sec.id)} 
              style={{
                ...styles.navLinkButton, 
                color: activeSection === sec.id ? designTokens.gold : '#94a3b8',
                padding: '8px 0',
                fontSize: '16px' // Enhanced tap target accessibility for phones
              }}
            >
              {sec.label}
            </button>
          ))}
          
          {/* APPLY NOW CALL TO ACTION */}
          <button 
            type="button" 
            className="nav-action-btn"
            onClick={() => handleNavClick('apply')} 
            style={styles.navBtn}
          >
            Apply Now →
          </button>
        </div>

      </div>
    </nav>
  );
}